var map = {
	"./about-us-banner.webp": 219,
	"./anniversary-banner-bm.webp": 1659,
	"./anniversary-banner-cn.webp": 1660,
	"./anniversary-banner-id.webp": 1661,
	"./anniversary-banner.webp": 1662,
	"./banner-01.jpg": 1663,
	"./banner-slot.jpg": 1664,
	"./bet-and-earn-banner-cn.webp": 1665,
	"./bet-and-earn-banner-indon.webp": 1666,
	"./bet-and-earn-banner-ms.webp": 1667,
	"./bet-and-earn-banner.webp": 1668,
	"./check-in-banner-cn.webp": 1669,
	"./check-in-banner-id.webp": 1670,
	"./check-in-banner-ms.webp": 1671,
	"./check-in-banner.webp": 1672,
	"./cny_2024-bm.webp": 1673,
	"./cny_2024-cn.webp": 1674,
	"./cny_2024.webp": 1675,
	"./epl-banner-cn.jpg": 1676,
	"./epl-banner-cn.webp": 1677,
	"./epl-banner-indo.jpg": 1678,
	"./epl-banner-indo.webp": 1679,
	"./epl-banner-ms.jpg": 1680,
	"./epl-banner-ms.webp": 1681,
	"./epl-banner.jpg": 1682,
	"./epl-banner.webp": 1683,
	"./games-banner-bm.webp": 1684,
	"./games-banner-cn.webp": 1685,
	"./games-banner-id.webp": 1686,
	"./games-banner.webp": 1687,
	"./lb-m-banner-cn.webp": 1688,
	"./lb-m-banner.webp": 1689,
	"./leaderboard-banner-cn.webp": 1690,
	"./leaderboard-banner.webp": 1691,
	"./lottery-banner.webp": 1692,
	"./lottery-banners-bm.webp": 1693,
	"./lottery-banners-cn.webp": 1694,
	"./lottery-banners-id.webp": 1695,
	"./lottery-banners.webp": 1696,
	"./lucky-spin-banner-cn.webp": 1697,
	"./lucky-spin-banner-ms.webp": 1698,
	"./lucky-spin-banner.webp": 1699,
	"./p2p-banner.webp": 1700,
	"./p2p-banners-bm.webp": 1701,
	"./p2p-banners-cn.webp": 1702,
	"./p2p-banners-id.webp": 1703,
	"./p2p-banners.webp": 1704,
	"./premier-league-banner-cn.webp": 1705,
	"./premier-league-banner.webp": 1706,
	"./promos-banner-cn.webp": 1707,
	"./promos-banner-indon.webp": 1708,
	"./promos-banner-ms.webp": 1709,
	"./promos-banner.webp": 1710,
	"./promos-detail-banner.jpg": 1711,
	"./side-bar-banner.jpg": 1712,
	"./uefa24-prediction-bm.webp": 1713,
	"./uefa24-prediction-cn.webp": 1714,
	"./uefa24-prediction-id.webp": 1715,
	"./uefa24-prediction.webp": 1716,
	"./vip-banner-cn.webp": 1717,
	"./vip-banner-id.webp": 1718,
	"./vip-banner-ms.webp": 1719,
	"./vip-banner.webp": 1720,
	"./winner-leaderboard-banner-cn.webp": 1721,
	"./winner-leaderboard-banner.webp": 1722,
	"./world-cup-banner-cn.webp": 1723,
	"./world-cup-banner.webp": 1724,
	"./world-cup-two-banner-cn.webp": 1725,
	"./world-cup-two-banner.webp": 1726,
	"./xmas_2023-bm.jpg": 1727,
	"./xmas_2023-cn.jpg": 1728,
	"./xmas_2023-id.jpg": 1729,
	"./xmas_2023.jpg": 1730,
	"./xmas_2024-bm.webp": 1731,
	"./xmas_2024-cn.webp": 1732,
	"./xmas_2024.webp": 1733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;